const apiURL = "https://api.calzadoiconic.com/api/";

export default apiURL;
